module.exports = __webpack_public_path__ + "img/ley-incendios02.cc1af4c3.jpg";